var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c("h2", [_vm._v("Hello" + _vm._s(_vm.currentUserName) + "!")]),
      _vm._v(" "),
      _c("h3", { staticClass: "orangetitle" }, [_vm._v("My Submissions")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "submissionstable",
          attrs: {
            data: _vm.tableData,
            "empty-text": "There are no submissions yet.",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "Date", width: "110" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "title", label: "Project Title", width: "180" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "entry_id",
              label: "Entry ID",
              align: "center",
              width: "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "category", label: "Category" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "fee", align: "center", label: "Fee", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "proforma",
              label: "Pre-Invoice",
              "class-name": "invoicecol",
              width: "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.proforma
                      ? _c(
                          "a",
                          {
                            staticClass: "invoicedown",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.getInvoice(
                                  scope.row.proforma,
                                  "proforma"
                                )
                              },
                            },
                          },
                          [
                            _vm._v("Download "),
                            _c("i", { staticClass: "el-icon-bottom" }),
                          ]
                        )
                      : _c("span", [_vm._v("N/A")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "invoice",
              label: "Invoice",
              "class-name": "invoicecol",
              width: "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.invoice
                      ? _c(
                          "a",
                          {
                            staticClass: "invoicedown",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.getInvoice(
                                  scope.row.invoice,
                                  "invoice"
                                )
                              },
                            },
                          },
                          [
                            _vm._v("Download "),
                            _c("i", { staticClass: "el-icon-bottom" }),
                          ]
                        )
                      : _c("span", [_vm._v("N/A")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          layout: "prev, pager, next, total",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }